const ResizeHandle = ({ side, onMouseDown }) => {
    const getStyles = () => {
        const baseStyles = {
            position: 'absolute',
            zIndex: 10,
        };
        switch (side) {
            case 'right':
                return {
                    ...baseStyles,
                    right: 0,
                    top: 0,
                    width: 8,
                    height: '100%',
                    cursor: 'ew-resize',
                };
            case 'left':
                return {
                    ...baseStyles,
                    left: 0,
                    top: 0,
                    width: 8,
                    height: '100%',
                    cursor: 'ew-resize',
                };
            case 'bottom':
                return {
                    ...baseStyles,
                    left: 0,
                    bottom: 0,
                    width: '100%',
                    height: 8,
                    cursor: 'ns-resize',
                };
            default:
                return baseStyles;
        }
    };

    return <div style={getStyles()} onMouseDown={onMouseDown} />;
};

export default ResizeHandle;
